export enum TimerStage {
  NotInit = 0,
  Started = 1,
  Stopped = -1,
}
